<template>
  <div>
    <v-row>
      <v-data-table
        :headers="transponderHeaders"
        :items="transponderItems"
        sort-by="year"
        class="elevation-1"
        :no-data-text="$t('page.events.createRegistrant.transponder.no_data')"
        :footer-props="{
          'items-per-page-text': $t('dataTable.rowsPerPageText'),
          'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
        }"
        :headerProps="{
          'sort-by-text': $t('dataTable.sortByText')
        }"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-dialog v-model="dialog" max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >{{ $t("page.events.createRegistrant.transponder.add_transponder") }}</v-btn>
              </template>
              <v-card>
                <v-form ref="form">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col md="12">
                          <v-text-field
                            v-model="form.tagid"
                            :label="$t('page.events.createRegistrant.transponder.add_transponder')"
                            :rules="rules.tagid"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="createTransponder"
                      color="darken-1" dark small
                      class="btn mb-2"
                      :disabled="!transponderFormIsValid"
                    >{{ btnTitle }}</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <!--No se pudo verificar-->
            <v-dialog v-model="dialogDelete" max-width="600px">
              <v-card>
                <v-card-title class="headline">{{ $t('page.events.createRegistrant.transponder.delete_transponder') }}</v-card-title>
                <v-card-text>
                  <p class="mt16">{{ $t('page.events.createRegistrant.transponder.sure_delete') }}</p>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-row>
                    <v-col>
                      <v-btn
                        class="btn mb-2"
                        text
                        @click="closeDelete"
                      >{{ $t('page.events.createRegistrant.transponder.cancel') }}</v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="primary"
                        class="btn mb-2"
                        text
                        @click="deleteItemConfirm"
                      >{{ $t('page.events.createRegistrant.transponder.delete') }}</v-btn>
                    </v-col>
                  </v-row>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Transponder",
  data() {
    const transponderForm = Object.freeze({
      tagid: ""
    });
    return {
      dialog: false,
      editedIndex: -1,
      dialogDelete: false,
      transponderForm,
      form: Object.assign({}, transponderForm),
      rules: {
        tagid: [val => (val || "").length > 0 || this.$t("page.events.createRegistrant.transponder.tagid")]
      },
      transponderHeaders: [
        {
          text: this.$t("page.events.createRegistrant.transponder.tag_id"),
          align: "",
          sortable: false,
          value: "tagid"
        },
        { text: this.$t("page.events.createRegistrant.transponder.created_date"), value: "created_date" },
        {
          text: this.$t("page.events.createRegistrant.transponder.date_last_used"),
          value: "date_last_used"
        },
        {
          text: this.$t("page.events.createRegistrant.transponder.actions"),
          value: "actions",
          sortable: false
        }
      ],
      transponderItems: [],
      defaultItem: {
        tagid: "",
        created_date: "01/12/2020",
        date_last_used: "01/12/2020"
      }
    };
  },
  computed: {
    transponderFormIsValid() {
      return this.form.tagid;
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("page.events.createRegistrant.transponder.add_transponder")
        : this.$t("page.events.createRegistrant.transponder.update_transponder");
    },
    btnTitle() {
      return this.editedIndex === -1
        ? this.$t("page.events.createRegistrant.transponder.create")
        : this.$t("page.events.createRegistrant.transponder.update");
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    }
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.transponderItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.transponderItems.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.transponderItems.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.form = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    createTransponder() {
      this.form.created_date = "01/12/2020";
      this.form.date_last_used = "01/12/2020";
      if (this.editedIndex > -1) {
        Object.assign(this.transponderItems[this.editedIndex], this.form);
      } else {
        this.transponderItems.push(this.form);
      }
      this.close();
    }
  }
};
</script>

<style scoped>
.v-data-table-header,
.v-card__title {
  background: #ccc;
}
.v-data-table {
  width: 100%;
  margin: 20px;
}
.mt16 {
  margin-top: 16px;
}
</style>
